module.exports = __webpack_public_path__ + "img/LF_24-50.d57d4b33.svg";